<template>
  <section id="products">
    <router-view />
  </section>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>
